import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { createEvent } from '@perpay-web/fintech/actions/entities/events';
import { analyticsPayrollInstructionsViewed as analyticsPayrollInstructionsViewedAction } from '@perpay-web/fintech/actions/entities/instructions';
import { routeToLocation } from '@perpay-web/fintech/actions/router';
import PayrollInstructionsFlow from '@perpay-web/fintech/components/composite/PayrollInstructionsFlow/PayrollInstructionsFlow';
import { PAYROLL_INSTRUCTIONS_SET_UP_LATER } from '@perpay-web/fintech/constants/eventTypes';
import {
    payrollInstructionsFlowDataModule,
    getUserStatusToInstructionsType,
} from '@perpay-web/fintech/dataModules/composed/payrollInstructionsFlow';
import { fetchPayrollInstructionsDataModule } from '@perpay-web/fintech/dataModules/fetchPayrollInstructions';
import { paths } from '@perpay-web/fintech/props/appPaths';

const PayrollInstructionsFlowContainer = ({
    closeWhenSupportToolLaunched,
    instructionsType,
    customAmount,
    inModal,
    onClickFinished: ownPropsOnClickFinished,
    onClickBackFromModal,
    onClickNeedHelpFromModal,
    flowType = null,
}) => {
    const dispatch = useDispatch();
    const isPayrollInstructionsFlowLoading = useSelector(
        payrollInstructionsFlowDataModule.getIsLoadingOrUnrequested,
    );
    const isFetchPayrollInstructionsLoading = useSelector(
        fetchPayrollInstructionsDataModule.getIsLoadingOrUnrequested,
    );
    const isLoading =
        isPayrollInstructionsFlowLoading || isFetchPayrollInstructionsLoading;

    const userStatusToInstructionsType = useSelector(
        getUserStatusToInstructionsType,
    );

    /* The dataRequests made here are consumed in `PayrollInstructionsContainer` */
    const onMount = useCallback(() => {
        dispatch(payrollInstructionsFlowDataModule.dataRequest());
        dispatch(
            fetchPayrollInstructionsDataModule.dataRequest({
                instructionsType,
                amount: customAmount,
            }),
        );
    }, [customAmount, dispatch, instructionsType]);

    const analyticsPayrollInstructionsViewed = useCallback(
        () => dispatch(analyticsPayrollInstructionsViewedAction()),
        [dispatch],
    );

    const onClickFinished = useCallback(() => {
        ownPropsOnClickFinished
            ? ownPropsOnClickFinished()
            : dispatch(routeToLocation(paths.dashboard.path));
    }, [dispatch, ownPropsOnClickFinished]);

    const onClickSetUpPaymentsLater = useCallback(
        () => dispatch(createEvent(PAYROLL_INSTRUCTIONS_SET_UP_LATER)),
        [dispatch],
    );

    const resetPayrollInstructions = useCallback(
        () => dispatch(fetchPayrollInstructionsDataModule.dataReset()),
        [dispatch],
    );

    return (
        <PayrollInstructionsFlow
            closeWhenSupportToolLaunched={closeWhenSupportToolLaunched}
            loading={isLoading}
            instructionsType={instructionsType || userStatusToInstructionsType}
            onMount={onMount}
            analyticsPayrollInstructionsViewed={
                analyticsPayrollInstructionsViewed
            }
            onClickFinished={onClickFinished}
            onClickSetUpPaymentsLater={onClickSetUpPaymentsLater}
            resetPayrollInstructions={resetPayrollInstructions}
            inModal={inModal}
            onClickBackFromModal={onClickBackFromModal}
            onClickInstructionsBack={onClickBackFromModal}
            onClickNeedHelpFromModal={onClickNeedHelpFromModal}
            flowType={flowType}
        />
    );
};

export default PayrollInstructionsFlowContainer;
